export default __webpack_public_path__ + "static/media/product-5.d20c3f0f.png";